<template>
  <div class="CardProductSpecsCmp h-100">
    <component
      :is="dataHref !== '' ? 'a' : 'div'"
      :href="dataHref !== '' ? dataHref : null"
      :target="dataHref !== '' ? dataTarget : null"
      class="card-link h-100"
    >
      <div
        v-if="hasSlot($slots.title, $scopedSlots.title)"
        class="title-wrapper a-paragraph-1"
      >
        <slot name="title" />
      </div>
      <figure
        v-if="hasSlot($slots.image, $scopedSlots.image)"
        class="image-wrapper"
      >
        <slot name="image" />
      </figure>
      <div
        v-if="hasSlot($slots.specs, $scopedSlots.specs)"
        class="specs-wrapper a-support"
      >
        <slot name="specs" />
      </div>
    </component>
  </div>
</template>

<script>
import { hasSlot } from '@/helpers/cms-support';

export default {
  name: 'CardProductSpecsCmp',
  props: {
    dataHref: {
      type: String,
      default: '',
    },
    dataTarget: {
      type: String,
      default: null,
    },
  },
  setup() {
    return { hasSlot };
  },
};
</script>

<style lang="scss" scoped>
.CardProductSpecsCmp {
  color: $color-bronze;

  .card-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $color-white;
    border: 2px solid $color-blue-10;
    border-radius: 8px;
    transition: border-color 1s ease;
    padding: 16px;
    gap: 16px;

    @include media-breakpoint-up(lg) {
      padding: 24px;
      gap: 24px;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 212px;

    @include media-breakpoint-up(lg) {
      height: 240px;
    }

    img {
      display: block;
      width: auto;
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
      transition: transform 1s;
      transform: scale(0.9);
    }
  }

  &:hover {
    .card-link {
      border-color: $color-blue;
    }

    .image-wrapper {
      img {
        transform: scale(1.1);
      }
    }
  }

  .specs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
  }
}
</style>
